export default __webpack_public_path__ + "static/media/HSL_auto_renewing_subscriptions_14.1.2021.dcf482ca.pdf";